import React from "react";
import { Link } from "react-router-dom";
import useDocumentTitle from "../hooks/useDocumentTitle";

export default function NotFound() {
  useDocumentTitle("404 · Not Found — QorTrace");
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen w-full flex items-center justify-center px-6"
      style={{ background: "#000000" }}
    >
      <div className="max-w-xl w-full">
        <div
          className="text-xs tracking-[0.25em] uppercase mb-6"
          style={{
            color: "#7AE7F2",
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
          }}
          data-testid="not-found-eyebrow"
        >
          404 · Route not found
        </div>

        <h1
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight mb-5"
          data-testid="not-found-heading"
        >
          This signature didn&rsquo;t verify.
        </h1>

        <p className="text-base text-white/70 mb-10 max-w-md">
          The page you&rsquo;re looking for doesn&rsquo;t exist or was moved. Try one of the routes
          below to get back on chain.
        </p>

        <div className="flex flex-wrap gap-3" data-testid="not-found-cta-row">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold tracking-wide transition-colors"
            style={{ background: "#7AE7F2", color: "#001018" }}
          >
            Go to homepage
            <span aria-hidden="true">&rarr;</span>
          </Link>
          <Link
            to="/free-scan"
            data-testid="not-found-freescan-link"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold tracking-wide border transition-colors text-white/90 hover:text-white"
            style={{ borderColor: "rgba(122,231,242,0.35)" }}
          >
            Run a free scan
          </Link>
          <Link
            to="/verify"
            data-testid="not-found-verify-link"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold tracking-wide border transition-colors text-white/90 hover:text-white"
            style={{ borderColor: "rgba(122,231,242,0.35)" }}
          >
            Verify a certificate
          </Link>
        </div>
      </div>
    </div>
  );
}
